import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AttentionToModule } from "@vp/shared/directives/attention-to";
import { FlexModule } from "@vp/shared/directives/flex";
import { PrettyJsonModule } from "@vp/shared/pipes/pretty-json";
import { AddTagModule } from "@vp/tag-manager/ui/add-tag";
import { TagEditorModule } from "@vp/tag-manager/ui/tag-editor";
import { TagManagerActionRowModule } from "@vp/tag-manager/ui/tag-manager-action-row";
import { TagMenuSelectorModule } from "@vp/tag-manager/ui/tag-menu-selector";
import { TagSearchInputModule } from "@vp/tag-manager/ui/tag-search-input";
import { TagTypeMenuSelectorModule } from "@vp/tag-manager/ui/tag-type-menu-selector";
import { TagManagerShellComponent } from "./tag-manager-shell.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatToolbarModule,
    MatTooltipModule,
    TagSearchInputModule,
    TagTypeMenuSelectorModule,
    TagMenuSelectorModule,
    TagEditorModule,
    AttentionToModule,
    PrettyJsonModule,
    TagManagerActionRowModule,
    AddTagModule,
    FlexModule
  ],
  declarations: [TagManagerShellComponent],
  exports: [TagManagerShellComponent]
})
export class TagManagerShellModule {}
